import {
  BulkAssemblyProcedure,
  CLIENT_PROCEDURE_JSON_CURRENT_VERSION,
} from 'molbio/bulk-assembly/BulkAssemblyConstants';
import {AsyncBulkAssemblyValidationResults} from 'molbio/bulk-assembly/BulkAssemblyValidationConstants';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface SaveInformation {
  folderId: string;
  tagSchemaId: string | null;
  worklistId: string | null;
  newWorklistName: string | null;
}

export interface FinalizationLocationInfo {
  fragmentSaveInfo: SaveInformation | null;
  constructSaveInfo: SaveInformation;
  primerSaveInfo: SaveInformation | null;
}

export function createAssembly({
  name,
  folderId,
  procedureJson,
}: {
  name: string;
  folderId: string;
  procedureJson: BulkAssemblyProcedure;
}): Promise<{id: string}> {
  return net.postJSONPromise({
    url: '/1/api/bulk-assemblies',
    data: {
      name,
      folderId,
      procedureJson: {version: CLIENT_PROCEDURE_JSON_CURRENT_VERSION, contents: procedureJson},
    },
  });
}

export function patchBulkAssembly(assemblyId: string, procedureJson?: BulkAssemblyProcedure): Promise<{}> {
  return net.patchJSONPromise({
    url: `/1/api/bulk-assemblies/${assemblyId}`,
    data: {
      procedureJson:
        procedureJson != null
          ? {version: CLIENT_PROCEDURE_JSON_CURRENT_VERSION, contents: procedureJson}
          : undefined,
    },
  });
}

export function finalizeAssembly(
  finalizationParams: {
    bulkAssemblyId: string;
    procedureJson: BulkAssemblyProcedure;
  } & FinalizationLocationInfo
): Promise<{}> {
  return Promise.resolve(
    TaskRunner.postJSONPromise({
      url: '/1/api/bulk-assemblies:finalize',
      data: {
        ...finalizationParams,
        procedureJson: {
          version: CLIENT_PROCEDURE_JSON_CURRENT_VERSION,
          contents: finalizationParams.procedureJson,
        },
      },
    })
  );
}

export function asyncValidateAssembly(
  bulkAssemblyId: string,
  procedureJson: BulkAssemblyProcedure
): Promise<AsyncBulkAssemblyValidationResults> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/bulk-assemblies/async-validate',
    data: {
      bulkAssemblyId,
      procedureJson: {
        version: CLIENT_PROCEDURE_JSON_CURRENT_VERSION,
        contents: procedureJson,
      },
    },
  });
}
